import { useEffect } from 'react';
import { FormBase } from 'src/snack/components/Form/FormBase';
import { FormBaseProps } from 'src/uikit/Form';

import { useAnalytics } from '../../../../hooks/useAnalytics';
import { Modal } from '../../Modal';

export function ModalForm({ modalClose, ...props }: FormBaseProps) {
  const { formViewSent } = useAnalytics();
  useEffect(() => {
    formViewSent({
      typeView: 'pop-up',
      formName: props.successfulSubmissonFormAnalytics?.formname ?? 'other',
    });
  }, []);
  return (
    <>
      {modalClose && (
        <Modal open={true} onClose={modalClose}>
          <FormBase
            {...props}
            successfulSubmissonFormAnalytics={
              props.successfulSubmissonFormAnalytics && {
                zoneclick:
                  props.successfulSubmissonFormAnalytics.zoneclick || 'P',
                formname: props.successfulSubmissonFormAnalytics?.formname,
              }
            }
            allFormsSentIsPopup
          />
        </Modal>
      )}
    </>
  );
}
